import { render, staticRenderFns } from "./Inexplist.vue?vue&type=template&id=ef2ce44c&scoped=true"
import script from "./Inexplist.vue?vue&type=script&lang=js"
export * from "./Inexplist.vue?vue&type=script&lang=js"
import style0 from "./Inexplist.vue?vue&type=style&index=0&id=ef2ce44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2ce44c",
  null
  
)

export default component.exports